import { FC } from 'react';
import { Helmet } from 'react-helmet-async';
import { PageHeader } from 'components/page-header';
import { pageTitle } from 'utils/page-title';
import DivisionOrdersContent from './division-orders-content';
import {
  AddDocumentSidePanel,
  DocumentUploadConfig,
} from 'components/add-document-modal/add-document-side-panel';

const DIVISION_ORDER_UPLOAD_CONFIG: DocumentUploadConfig = {
  documentType: 'division_order',
  promptCategory: 'division_order_document_fields',
  accept: ['.pdf', '.tif', '.tiff'],
  uploadHelperText: 'Upload a single PDF or TIFF file (max 500 MB limit)',
  promptHelperText: 'For division order documents',
  idPrefix: 'do-',
  errorFallback: 'Problem uploading division order document',
};

const DivisionOrdersListPage: FC = () => {
  return (
    <>
      <Helmet>
        <title>{pageTitle('Division Orders')}</title>
      </Helmet>
      <PageHeader
        breadcrumbs={[]}
        title="Division Orders"
        actions={
          <AddDocumentSidePanel
            triggerLabel="Add Division Order"
            title="Add Division Order"
            subtitle="Upload a division order document to begin processing."
            config={DIVISION_ORDER_UPLOAD_CONFIG}
          />
        }
      />
      <DivisionOrdersContent />
    </>
  );
};

export { DivisionOrdersListPage };
